export default {
    CancelConvertClassicToCloudy: {
        name: 'CancelConvertClassicToCloudy',
    },
    CancelConvertCloudyToClassic: {
        name: 'CancelConvertCloudyToClassic',
    },
};
